import React from "react";
import { LinkOptions } from "@/components/link";
import { PayrollInspectLink } from "./PayrollInspectLink";
import { PayrollAggregateLink } from "./PayrollAggregateLink";
import { PayrollSplitLink } from "./PayrollSplitLink";
import { usePayrollPermissions } from "../hooks/usePayrollPermissions";

interface PayrollActionLinksProps {
  inspectOptions?: LinkOptions;
  aggregateOptions?: LinkOptions;
  splitOptions?: LinkOptions;
}

export const PayrollActionLinks: React.FC<PayrollActionLinksProps> = ({
  inspectOptions,
  aggregateOptions,
  splitOptions,
}) => {
  const permissions = usePayrollPermissions();

  const splitLinkOptions = permissions.canAccessSplit
    ? splitOptions
    : { isGrayed: true, isDisabled: true };

  return (
    <>
      <PayrollInspectLink options={inspectOptions} />
      <PayrollAggregateLink options={aggregateOptions} />
      <PayrollSplitLink options={splitLinkOptions} />
    </>
  );
};
